import { default as Container } from './SoldExclusivesContainer';
import { default as Component } from './SoldExclusivesSection';
export default Container(Component);
